import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Box,
  Icon,
  MenuItem,
  Menu,
  Card,
  CardContent,
} from '@mui/material';
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Container from "@mui/material/Container";
import { LocationOn } from '@mui/icons-material';
import MKButton from "components/MKButton";
import Logo from "assets/images/skill2.png";
import CompanyIcon from "assets/images/companyicon.png";

const Page = () => {
  const [topTrainingData, setTopTrainingData] = useState([]);
  const [topTrainingName, setTopTrainingName] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [topTrainingMode, setTopTrainingMode] = useState([]);
  const [topTrainingBudget, setTopTrainingBudget] = useState([]);
  const [topTrainingTechnology, setTopTrainingTechnology] = useState([]);
  const trainingsPerSlide = 3;
  const [searchValue, setSearchValue] = useState('');
  const [searchOption, setSearchOption] = useState('Training Name');
  const [searchDropdown, setSearchDropdown] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/training-page-less/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          let totalData = data;
          setTopTrainingData(totalData);
          let names = totalData.map(item => item.trainingName);
          setTopTrainingName(names);
          let technology = totalData.map(item => item.technology);
          setTopTrainingTechnology(technology);
          let mode = totalData.map(item => item.trainingMode);
          setTopTrainingMode(mode);
          let budget = totalData.map(item => item.totalTrainingBudget);
          setTopTrainingBudget(budget);
          setLoading(true);
          setDataLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("topTrainingData", topTrainingData);
  console.log("topTrainingName", topTrainingName);
  console.log("topTrainingTechnology", topTrainingTechnology);
  console.log("topTrainingMode", topTrainingMode);
  console.log("topTrainingBudget", topTrainingBudget);


  const totalSlides = Math.ceil(topTrainingName.length / trainingsPerSlide);

  const handlePrevSlide = () => {
    setCurrentSlide(prevSlide => {
      if (prevSlide === 0) {
        return Math.max(totalSlides - 1, 0);
      }
      return Math.max(prevSlide - 1, 0);
    });
  };

  const handleNextSlide = () => {
    setCurrentSlide(prevSlide => {
      if (prevSlide === totalSlides - 1) {
        return 0;
      }
      return Math.min(prevSlide + 1, totalSlides - 1);
    });
  };

  useEffect(() => {
    if (dataLoaded && !isSearching) {
      const intervalId = setInterval(() => {
        handleNextSlide();
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [dataLoaded, currentSlide, isSearching]);
  console.log("currentSlide", currentSlide);

  const filterTrainingData = () => {
    const searchLowerCase = searchValue.toLowerCase();

    return topTrainingData.filter((item) => {
      if (searchOption === 'Training Name') {
        return item.trainingName.toLowerCase().includes(searchLowerCase);
      } else if (searchOption === 'Technology') {
        return item.technology.toLowerCase().includes(searchLowerCase);
      } else if (searchOption === 'Company Name') {
        return item.trainingCompanyName.toLowerCase().includes(searchLowerCase);
      }

      return false;
    });
  };

  const filteredTrainingData = filterTrainingData();

  const handleSearchChange = event => {
    const searchInput = event.target.value;
    setSearchValue(searchInput);

    setIsSearching(searchInput.trim() !== '');
  };


  const openSearchDropdown = (event) => {
    setSearchDropdown(event.currentTarget);
  };

  const closeSearchDropdown = () => {
    setSearchDropdown(null);
  };

  const handleSearchOptionChange = option => {
    setSearchOption(option);
    setSearchValue('');
    closeSearchDropdown();
  };

  // const renderTrainingsInSlide = () => {
  //   // const startIndex = currentSlide * trainingsPerSlide;
  //   // const endIndex = startIndex + trainingsPerSlide;
  //   // const trainingsToShow = isSearching ? filteredTrainingData : topTrainingData.slice(startIndex, endIndex);

  //   const startIndex = currentSlide * trainingsPerSlide;
  //   const endIndex = startIndex + trainingsPerSlide;
  //   const trainingsToShow = isSearching ? filteredTrainingData : topTrainingData.slice(startIndex, endIndex);

  //   if (startIndex + trainingsPerSlide > topTrainingData.length) {
  //     const remainingImages = trainingsPerSlide - topTrainingData.length;
  //     const additionalImages = topTrainingData.slice(0, remainingImages);
  //     trainingsToShow.push(...additionalImages);
  //   }

  //   if (loading) {
  //     return trainingsToShow.map((training, index) => (
  //       <div key={index} style={{ width: '500px', margin: '15px' }}>
  //         <Card style={{ height: '170px' }} sx={{
  //           backgroundColor: '#501d1b',
  //           color: '#FFFFFF',
  //           border: '1px solid #FFFFFF'
  //         }}>
  //           <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', height: '170px' }}>
  //             <Typography variant="h5" style={{ marginTop: '5px', color: '#FFFFFF' }}>{training.trainingName}</Typography>
  //             <Typography>
  //               <span style={{ fontSize: '1rem', color: '#FFFFFF' }}>
  //                 <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
  //               </span>
  //             </Typography>
  //             <Typography style={{ marginTop: '-5px' }}>
  //               <span style={{ fontSize: '1rem', color: '#FFFFFF' }}>
  //                 <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
  //                 {training.technology}
  //               </span>
  //             </Typography>
  //             <Typography style={{ marginTop: '-5px' }}>
  //               <span style={{ fontSize: '1rem', color: '#FFFFFF' }}>
  //                 <LocationOn /> {training.trainingMode} | {training.currency}&nbsp;{training.totalTrainingBudget}
  //               </span>
  //             </Typography>
  //           </CardContent>

  //         </Card>
  //       </div>
  //     ));
  //   };
  // }

  const renderTrainingsInSlide = () => {
    const startIndex = currentSlide * trainingsPerSlide;
    const endIndex = startIndex + trainingsPerSlide;
    let trainingsToShow = isSearching ? filteredTrainingData : topTrainingData.slice(startIndex, endIndex);
  
    if (!isSearching) {
      if (trainingsToShow.length < trainingsPerSlide) {
        const remainingCount = trainingsPerSlide - trainingsToShow.length;
        const additionalTrainings = topTrainingData.slice(0, remainingCount);
        trainingsToShow = [...trainingsToShow, ...additionalTrainings];
      }
    }
  
    if (loading) {
      return trainingsToShow.map((training, index) => (
        <div key={index} style={{ width: '500px', margin: '15px' }}>
          <Card style={{ height: '170px' }} sx={{
            backgroundColor: '#501d1b',
            color: '#FFFFFF',
            border: '1px solid #FFFFFF'
          }}>
            <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', height: '170px' }}>
              <Typography variant="h5" style={{ marginTop: '5px', color: '#FFFFFF' }}>{training.trainingName}</Typography>
              <Typography>
                <span style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                </span>
              </Typography>
              <Typography style={{ marginTop: '-5px' }}>
                <span style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                  {training.technology}
                </span>
              </Typography>
              <Typography style={{ marginTop: '-5px' }}>
                <span style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  <LocationOn /> {training.trainingMode} | {training.currency}&nbsp;{training.totalTrainingBudget}
                </span>
              </Typography>
            </CardContent>
  
          </Card>
        </div>
      ));
    }
  };

  return (
    <>
      <Grid container spacing={2} style={{ marginBottom: "-50px" }}>
        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
            <span style={{ color: 'black' }}>Explore More</span>{' '}
            <span style={{ color: '#2e1114' }}>Trainings</span>
          </MKTypography>
        </Grid>
      </Grid>
      <MKBox component="section" py={12} style={{ marginBottom: "-50px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Container>
          <Grid container item xs={12} lg={8} py={1} mx="auto">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', marginLeft: '150px' }}>
                <MKInput
                  variant="standard"
                  placeholder={`Search ${searchOption}`}
                  style={{ width: "400px" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                  value={searchValue}
                  onChange={handleSearchChange}
                />
                <MKButton variant="gradient" color="info" onClick={openSearchDropdown} style={{ marginLeft: '10px' }}>
                  {searchOption || 'Search Option *'} <Icon>expand_more</Icon>
                </MKButton>
              </div>
              <Menu anchorEl={searchDropdown} open={Boolean(searchDropdown)} onClose={closeSearchDropdown}>
                <MenuItem onClick={() => handleSearchOptionChange('Training Name')}>Training Name</MenuItem>
                <MenuItem onClick={() => handleSearchOptionChange('Company Name')}>Company Name</MenuItem>
                <MenuItem onClick={() => handleSearchOptionChange('Technology')}>Technology</MenuItem>
              </Menu>
            </div>
          </Grid>
        </Container>
      </MKBox>
      <Grid container spacing={2} style={{ marginBottom: "30px" }}>
        <Grid item xs={1}>
          <Icon style={{ marginTop: '80px' }} onClick={handlePrevSlide}>keyboard_arrow_left</Icon>
        </Grid>
        <Grid item xs={10}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            {renderTrainingsInSlide()}
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Icon style={{ marginTop: '80px' }} onClick={handleNextSlide}>keyboard_arrow_right</Icon>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default Page;